<template>
  <div class="addtocart addtocart_product">
    <div class="addtocart__inner">
      <div
        id="addcartContainerOuter"
        class="productCart__container"
        :class="{ showPopup: showPopup }"
      >
        <div class="outsideclick" @click="closePopupScreen()"></div>
        <div class="productCart__close productCart__close--product" @click="closePopupScreen()">
          &#10006;
        </div>

        <div class="productCart__totalProduct">
          <span id="cartDataItemLength" class="cartDataItemLength">0</span
          ><b> {{ productLabel }}</b> {{ inYourCartLabel }}
        </div>

        <div
          v-if="cartData != undefined"
          id="productCartItemContainer"
          class="productCart__itemContainer"
        >
          <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
            <!-- productCart__item should repeated for multiple item -->
            <template v-if="cartDataStatus == basket">
              <div v-for="(cart, index) in cartData" :key="index" class="productCart__item">
                <div class="productCart__itemImage">
                  <img :src="cart.c_imageUrl" alt="" />
                </div>
                <div class="productCart__itemDetail">
                  <div class="productCart__itemName">{{ cart.item_text }}</div>
                  <!-- <div class="productCart__itemDescription">{{ cart.variant }}</div> -->
                  <!-- <div class="productCart__itemSize">{{ cart.variant }}</div> -->
                  <div
                    class="productCart__itemDelete"
                    @click="cartDataRemove(cart.item_id, cart.product_id)"
                  >
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAIAAAD5x3GmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0Y0NDU0RTJEN0MzMTFFQThDNENCRTgxOTYxNEM1RkYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0Y0NDU0RTNEN0MzMTFFQThDNENCRTgxOTYxNEM1RkYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozRjQ0NTRFMEQ3QzMxMUVBOEM0Q0JFODE5NjE0QzVGRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozRjQ0NTRFMUQ3QzMxMUVBOEM0Q0JFODE5NjE0QzVGRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppw+BZQAAADhSURBVHjarJNLDkRAEIaZzMoKJ3AEN7C2cg5LJ3AElg7hEm5gayNcwOME5ptU4tkjRlSi8lXX/3e1pFubtpEkibYNVnYanW9uD8NgWRYi13VlpSzLKIr6vjdNc5a90zQdx1GKpmnIlEVRrEdhcxxHGLMeBAHboybP2x+DgahxfgfKEeM49jxv+h100Qi/tP9D4QnDsK5rgAxf8mRZVlUVQIYvee6c7Y7Htm0lPz2n6zolPz3HMAwln3nyPPd9HyDDlzxiOPLyFmZq23b3BNZBdynkqvKquLkn/00XjYg/AgwAhUivQxQw+sUAAAAASUVORK5CYII="
                      alt=""
                    />
                  </div>
                </div>
                <div class="productCart__itemQtyPrice">
                  <div class="productCart__itemQuantity">
                    <select
                      name="quantity"
                      :value="cart.quantity"
                      :input="disableAddCart(cart.quantity, cart.product_id)"
                      @change="cartDataUpdate($event, cart.item_id)"
                    >
                      <option v-for="index in items" :key="index" :value="index">
                        {{ index }}
                      </option>
                    </select>
                  </div>
                  <div class="productCart__itemPrice">$ {{ cart.price_after_order_discount }}</div>
                </div>
              </div>
            </template>
          </vue-custom-scrollbar>
          <!-- Total price -->
          <div class="productCart__TotalPrice">
            <div class="productCart__TotalPriceLabel">{{ totalPriceLabel }}</div>
            <div class="productCart__TotalPriceData">$ {{ cartDataTotal }}</div>
          </div>
          <button class="productCart__MyBasket" @click="cartRedirect(checkoutUrl)">
            {{ myBasketLabel }}
          </button>
        </div>
        <div v-else id="productCartItemContainer" class="productCart__empty">
          {{ cartEmptyMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  name: 'addtocart',
  components: {
    vueCustomScrollbar,
  },
  props: {
    buttonlabel: { type: String },
    mybasketlabel: { type: String },
    cartemptymessage: { type: String },
    totalpricelabel: { type: String },
    productlabel: { type: String },
    inyourcartlabel: { type: String },
    maxQuantityOfProduct: { type: String },
    checkouturl: { type: String },
  },
  data() {
    return {
      buttonLabel: this.buttonlabel,
      myBasketLabel: this.mybasketlabel,
      cartEmptyMessage: this.cartemptymessage,
      totalPriceLabel: this.totalpricelabel,
      productLabel: this.productlabel,
      inYourCartLabel: this.inyourcartlabel,
      showPopup: false,
      producteanid: '',
      cartData: [],
      cartDataStatus: '',
      cartDataTotal: '',
      items: this.maxQuantityOfProduct,
      checkoutUrl: this.checkouturl,
      form: { key: 1 },
      disableButton: false,
      //key:this.quantity,
      settings: {
        //maxScrollbarLength: 60
      },
    };
  },
  mounted() {
    var reference = this;
    var addtocartbutton = document.getElementById('productAddToCartButton');
    var addtocartpopup = document.getElementById('productCart__handle');

    this.cartDataOnLoad();
    this.popupItem = this.$el;

    addtocartpopup.addEventListener('click', function () {
      reference.cartDataOnLoad();
      reference.cartPopup();
    });

    this.producteanid = addtocartbutton.getAttribute('data-id');
    addtocartbutton.addEventListener('click', function () {
      reference.cartDataAdd();
      reference.cartPopup();
      //reference.cartDataOnLoad();
    });
  },
  methods: {
    /* This function is to pass the API url */
    getData: function (url) {
      return fetch(url).then((response) => response.json());
    },
    /* This function is to pass the API url --ends here */

    /* This function is to add the product to cart on click of add to cart button */
    cartDataAdd: function () {
      this.getData(`/api/Connector/addtocart?productid=${this.producteanid}`).then((jsonData) => {
        this.cartResponseHandler(jsonData);
      });
    },
    /* This function is to add the product to cart on click of add to cart button --ends here */

    /* This function is to add the product to cart on load of the page */
    cartDataOnLoad: function () {
      this.getData(`/api/connector/getcart`).then((jsonData) => {
        this.cartResponseHandler(jsonData);
      });
    },
    /* This function is to add the product to cart on load of the page --ends here*/

    /* This function is to update the product to cart on change of quantity */
    cartDataUpdate: function (event, cartItemID) {
      this.getData(
        `/api/connector/alterquantity?itemId=${cartItemID}&quantity=${event.target.value}`,
      ).then((jsonData) => {
        this.cartResponseHandler(jsonData);
      });
    },
    /* This function is to update the product to cart on change of quantity --ends here*/

    /* This function is to remove the product to cart on click of delete icon */
    cartDataRemove: function (cartItemID, productID) {
      this.getData(`/api/connector/RemoveProduct?itemId=${cartItemID}`).then((jsonData) => {
        this.cartResponseHandler(jsonData);
      });
      if (this.producteanid == productID) {
        document.getElementById('productAddToCartButton').classList.remove('disable');
      }
    },
    /* This function is to add the product to cart on click of delete icon --ends here */

    /* This function is to redirect on checkout click */
    cartRedirect: function (urlCheckout) {
      fetch('/api/connector/checkout').then(function (response) {
        if (response.status == 200);
        {
          window.location = urlCheckout;
        }
      });
    },
    /* This function is to redirect on checkout click --ends here */

    /* This function is to json response return */
    cartResponseHandler: function (jsonData) {
      this.cartDataStatus = jsonData._type;
      this.cartData = jsonData.product_items;
      this.cartDataTotal = jsonData.product_total;
      this.cartItemLength();
    },
    /* This function is to json response return --ends here*/

    disableAddCart: function (cartQuantity, productID) {
      if (this.items == '') {
        this.items = 5;
      }
      this.items = parseInt(this.items);
      if (this.producteanid == productID) {
        if (cartQuantity >= this.items) {
          document.getElementById('productAddToCartButton').classList.add('disable');
        } else {
          document.getElementById('productAddToCartButton').classList.remove('disable');
        }
      }
    },

    /* This function is to show the mini cart on click of add to cart button or on click of cart icon in header nav */
    cartPopup: function () {
      const iscookiebanner = document.getElementsByClassName('cookie-banner');
      const addcartContainerOuter = document.getElementById('addcartContainerOuter');
      if (iscookiebanner.length > 0) {
        addcartContainerOuter.setAttribute('cookie-exist', 'cookie-exist');
      } else {
        addcartContainerOuter.removeAttribute('cookie-exist');
      }
      this.showPopup = true;
    },
    /* This function is to show the mini cart on click of add to cart button or on click of cart icon in header nav --ends here*/

    /* This function is to hide the mini cart on click of close icon */
    closePopupScreen: function () {
      this.showPopup = false;
    },
    /* This function is to hide the mini cart on click of close icon --ends here*/

    /* This function is to count the number of items in the cart */
    cartItemLength: function () {
      const productcartcount = document.getElementById('productCartCount');
      const cartdataitemlength = document.getElementById('cartDataItemLength');
      if (this.cartData) {
        productcartcount.innerHTML = this.cartData.length;
        cartdataitemlength.innerHTML = this.cartData.length;
      } else {
        productcartcount.innerHTML = 0;
        cartdataitemlength.innerHTML = 0;
      }
    },
    /* This function is to count the number of items in the cart --ends here*/

    scrollHanle() {
      //console.log(evt)
    },
  },
};
</script>

<style lang="scss" src="./addtocart.scss"></style>
<!-- <style lang="scss" src="./perfect-scrollbar.scss"></style> -->
